<template>
	<div class="top">
		<div class="top_head">
			<img class="logo" src="@/static/home/logo.png" alt="" />
			<div class="weather">
				<div class="wea_top">
					<img class="tianqi" src="@/static/top/tianqi.png" alt="" />
					<div class="wea_text">
						{{lstq.text}}
					</div>
					<div class="wea_text">
						{{lstq.temp}}℃
					</div>
					<div class="wea_text">
						{{year}}年{{month}}月{{day}}日
					</div>
				</div>
			</div>
		</div>
		<div class="top_bar">
			<div :class="currentIndex==index?'opt active':'opt'" v-for="(item,index) in list" :key="index" @click="optfun(item.path,index)">
				<div class="opt_name">
					{{item.name}}
				</div>
				<div class="opt_zang">
					{{item.remark}}
				</div>
			</div>
			<div class="language">
				<div class="lang_box">
					<div :class="lang==0?'langcode':'lang'" @click="langfun(0)">
						中文
					</div>
					<div :class="lang==1?'langcode':'lang'" @click="langfun(1)">
						EN
					</div>
					<div :class="lang==2?'langcode':'lang'" @click="langfun(2)">
						JP
					</div>
					<div :class="lang==3?'langcode':'lang'" @click="langfun(3)">
						KR
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	import { menuList,article } from "@/api/article";
	export default {
		data() {
			return {
				list:[],
				lstq:[],	
				day:new Date().getDate(),
				month:new Date().getMonth() + 1,
				year:new Date().getFullYear(),
				lang: 0,
				langlist:['zh','en','jp','kor'],
			}
		},
		props: {
		  currentIndex: {
		    type: Number,
			default:0
		  }
		},
		watch: {
			$route(to, from) {
				
			},
		}, 
		created() {
			this.lang = JSON.parse(localStorage.getItem("langs")) || 0
			let item = JSON.parse(localStorage.getItem('lstq'));
			if(item){	//检测是否为空
				if (item.expires < Date.now()) {	//检测是否过期
				    localStorage.removeItem('lstq');
					this.tq();
				} else {
					this.lstq = item.data
				}
			}else{
				this.tq();
			}
			
			if(JSON.parse(localStorage.getItem("ids"))){
				this.list = JSON.parse(localStorage.getItem("ids"))
				menuList({
					parentId:0,
					language: this.langlist[this.lang],
					belong:'site',   //site,mobile,offiaccount,mini 网站，手机，公众，小程序
				})
				.then((res) => {
					//头部菜单
					this.list = res.data;
					localStorage.setItem("ids", JSON.stringify(this.list));
				})
				.catch((error) => {
					console.log(error);
				});
			}else{
				menuList({
					parentId:0,
					language: this.langlist[this.lang],
					belong:'site',   //site,mobile,offiaccount,mini 网站，手机，公众，小程序
				})
				.then((res) => {
					//头部菜单
					this.list = res.data;
					localStorage.setItem("ids", JSON.stringify(this.list));
				})
				.catch((error) => {
					console.log(error);
				});
			}
		},
		methods: {
			optfun(e,index){
				if(index==0){
					if(this.$route.name == 'home'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'home',query:{}})
					}
				}else{
					if(this.$route.name == e){
						this.$router.push({name:'refresh',query:{index:index}})
					}else{
						this.$router.push({name:e,query:{index:index}})
					}
				}
			},
			
			async tq(){
				await this.$axios({
						url:"https://devapi.qweather.com/v7/weather/now?location=101201103&key=a9ba8c384da34f72a8e1247a151b7970",
				        method:"get",//get请求方式
						headers:{
							
						},
				    }).then(res=>{
						this.lstq = res.data.now
						let expires = Date.now() + 1000 * 60 * 60;
						localStorage.setItem('lstq', JSON.stringify({data: this.lstq, expires}));
				　　//请求成功
				}).catch(error=>{
						console.log(error)
				});
			},
			
			langfun(e){
				this.lang = e
				localStorage.setItem("langs", e);
				menuList({
					parentId:0,
					language: this.langlist[this.lang],
					belong:'site',   //site,mobile,offiaccount,mini 网站，手机，公众，小程序
				})
				.then((res) => {
					//头部菜单
					var ids = res.data;
					localStorage.setItem("ids", JSON.stringify(ids));
					if(this.$route.name == 'home'){
						this.$router.replace('/refresh')
					}else{
						this.$router.push({name:'home',query:{}})
					}
				})
				.catch((error) => {
					console.log(error);
				});
			},
			
			
		},
		
	}
</script>

<style scoped lang="less">
	.top{
		width: 98%;
		padding:0 1%;
		height: 100px;
		position: fixed;
		top: 0;
		left: 0;
		color: #fff;
		z-index: 100;
		animation:  topdm 1s;
		background-color: rgba(0, 0, 0, .73);
		display: flex;
		justify-content: space-between;
	}
	 @keyframes topdm {
	 	0%{
			transform: translateY(-100%);
		}
		100%{
			transform: translateY(0%);
		}
	 }
	.top_head{
		position: relative;
		display: flex;
		align-items: center;
	}
	.logo{
		width: 254px;
		height: 79px;
	}
	.weather{
		display: flex;
		flex-direction: column;
		align-items: flex-end;
		margin-left: 15px;
	}
	.wea_top{
		display: flex;
		
	}
	.tianqi{
		width: 18px;
		height: 18px;
	}
	.wea_text{
		margin-left: 10px;
		font-size: 14px;
	}
	.wea_name{
		font-size: 12px;
	}
	.language{
		display: flex;
	}
	.lang_box{
		width: 153px;
		margin-left: 14px;
		display: flex;
		justify-content: space-between;
	}
	.lang{
		width: 32px;
		height: 32px;
		line-height: 32px;
		text-align: center;
		border-radius: 10px;
		border: 1px solid #fff;
		font-size: 12px;
		color: #fff;
	}
	.langcode{
		width: 32px;
		height: 32px;
		line-height: 32px;
		text-align: center;
		border-radius: 10px;
		border: 1px solid #fff;
		font-size: 12px;
		color: #2f3e83;
		background-color: #fff;
	} 
	.top_bar{
		height: 100px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.opt{
		height: 100px;
		padding: 0 20px;
		min-width:60px;
		position: relative;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}
	.active{
		background-color: #59b75a;
	}
	.opt_name{
		font-size: 16px;
	}
	.opt_zang{
		margin-top: 5px;
		font-size: 12px;
		text-transform: uppercase;
	}
</style>